export class EnaioUpsertDocument {
    fileName: string;
    base64: string;
    useExtension: string;
}
